const locale = {
  MODAL_AUTHENTICATION_PRINCIPAL_TITLE: 'Autenticación en dos pasos',
  MODAL_AUTHENTICATION_SUBTITLE: '¿En qué consiste?',
  MODAL_AUTHENTICATION_SUBTITLE_DESCRIPTION: `La autenticación de dos factores (2FA) añade una capa extra de seguridad. En lugar de usar solo tu contraseña, también necesitarás un código de verificación enviado a tu teléfono para iniciar sesión. Esto ayuda a proteger tu cuenta contra accesos no autorizados.`,
  MODAL_AUTHENTICATION_OFF_SWITCH_TITLE: 'Activa la verificación 2FA con el interruptor',
  MODAL_AUTHENTICATION_ON_SWITCH_TITLE: '¡La autenticación en dos pasos ha sido activada!',
  MODAL_AUTHENTICATION_ON_SWITCH_DESCRIPTION:
    'Se ha enviado el código de autenticación en dos pasos a tu correo electrónico. Por favor, ingrésalo para continuar navegando por la plataforma.',
  LOADING_TEXT: 'Cargando',

  SET_OFF_TITLE_TEXT: '2FA no activado',
  SET_OFF_DESCRIPTION_TEXT: 'No se completó la activación.',
};

export default locale;
